import { useMemo } from 'react';
import parse from 'date-fns/parse';
import { useStore } from 'effector-react';
import { cart$ } from 'models/cart';
import {
  checkIsValidStartDate,
  getDateInFormat,
  getLocalizedMonthLabel,
} from 'utils/datesСalculation';

export const useGetDatesSuggestions = (product) => {
  const cart = useStore(cart$);

  return useMemo(() => {
    if (!cart) {
      return [];
    }

    return cart
      .filter((el) => el.id !== product.id)
      .reduce((acc, el) => {
        const startDate = parse(el.dates.start, 'dd/MM/yyyy', new Date());
        const endDate = parse(el.dates.end, 'dd/MM/yyyy', new Date());

        const isValid = checkIsValidStartDate(startDate);

        if (isValid) {
          const isSuggestionExist = acc.some(
            (suggestion) =>
              getDateInFormat(suggestion.startDate, 'dd/MM/yyyy') ===
                el.dates.start &&
              getDateInFormat(suggestion.endDate, 'dd/MM/yyyy') ===
                el.dates.end,
          );

          if (!isSuggestionExist) {
            acc.push({
              startDate,
              endDate,
              formattedStr: `${getLocalizedMonthLabel(
                'en-gb',
                startDate.getMonth(),
              ).substring(
                0,
                3,
              )} ${startDate.getDate()} - ${getLocalizedMonthLabel(
                'en-gb',
                endDate.getMonth(),
              ).substring(0, 3)} ${endDate.getDate()}`,
            });
          }
        }

        return acc;
      }, []);
  }, [cart, product]);
};
